import { createSlice } from "@reduxjs/toolkit";

export const inmatesSlice = createSlice({
  name: "inmates",
  initialState: {
    inmates: [],
    error01: false, // Error for basic search if nothing is entered
    error02: false, // Error for advanced search if nothing is selected
    error03: false, // Error if only one date in release date range is selected
    warning01: false, // Warning if search returns max amount of inmates
    failed: false, // Warning if search returns 0 inmates
    loading: false,
  },
  reducers: {
    insert: (state, action) => {
      state.inmates = action.payload;
    },
    reset: (state) => {
      state.inmates = [];
      state.error01 = false;
      state.error02 = false;
      state.error03 = false;
      state.warning01 = false;
      state.failed = false;
    },
    showError01: (state) => {
      state.error01 = true;
    },
    hideError01: (state) => {
      state.error01 = false;
    },
    showError02: (state) => {
      state.error02 = true;
    },
    hideError02: (state) => {
      state.error02 = false;
    },
    showError03: (state) => {
      state.error03 = true;
    },
    hideError03: (state) => {
      state.error03 = false;
    },
    showWarning01: (state) => {
      state.warning01 = true;
    },
    hideWarning01: (state) => {
      state.warning01 = false;
    },
    showFailed: (state) => {
      state.failed = true;
    },
    hideFailed: (state) => {
      state.failed = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state) => {
      state.loading = false;
    },
  },
});

export const {
  insert,
  reset,
  showError01,
  hideError01,
  showError02,
  hideError02,
  showError03,
  hideError03,
  showWarning01,
  hideWarning01,
  showFailed,
  hideFailed,
  showLoading,
  hideLoading,
} = inmatesSlice.actions;
export default inmatesSlice.reducer;
